import { useText } from "@/lib/content";
import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errorMessage } from "@/lib/api";
import { Notice } from "@/components/form/FormFeedback";
import { usePageTitle } from "@/components/layout/AppLayout";
import { AuthCard, TextInput } from "@/pages/Login";
import { MSG } from "@/lib/validators";

export default function ForgotPassword() {
    const t = useText();
    usePageTitle("Password dimenticata");
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [done, setDone] = useState("");
    const [failure, setFailure] = useState("");
    const [busy, setBusy] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setFailure("");
        if (!email.trim()) return setError(MSG.required);
        if (!/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(email.trim())) return setError(MSG.email);
        setError("");
        setBusy(true);
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setDone(data.message);
        } catch (err) {
            setFailure(errorMessage(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <AuthCard title={t("auth.forgot_title")} intro={t("auth.forgot_intro")}>
            {done ? (
                <div className="space-y-4">
                    <Notice kind="success" testId="forgot-success-message">{done}</Notice>
                    <Link to="/accedi" className="btn-tertiary" data-testid="forgot-back-login-link">Torna all'accesso</Link>
                </div>
            ) : (
                <form noValidate onSubmit={onSubmit} className="space-y-5" data-testid="forgot-form">
                    {failure && <Notice kind="error" role="alert">{failure}</Notice>}
                    <TextInput id="forgot-email" label="Email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} error={error} />
                    <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="forgot-submit-button">Invia il link</button>
                    <Link to="/accedi" className="text-sm inline-block">Torna all'accesso</Link>
                </form>
            )}
        </AuthCard>
    );
}
